// Type tool (T, M14): a click places a point text ("Text") with the brand's heading font and selects it;
// its text and style are edited in the Ad dock (no on-canvas caret in V2 — PRODUCT_SPEC_V2 §3).
import type { Tool, ToolHost, ToolPointer } from './tool';
import { useDesign } from '../state';
import { useDesignUi } from '../ui/designUi';
import { addNode } from '../commands/commands';
import { newId } from '../model/ids';
import { nearestWeight } from '../text/fontCatalog';
import type { TextNode } from '../model/types';

export class TypeTool implements Tool {
  down(p: ToolPointer) {
    const doc = useDesign.getState().doc;
    if (!doc) return;
    const f = nearestWeight(doc.brand?.headingFont ?? 'Montserrat', 700);
    const n: TextNode = {
      id: newId('t'),
      kind: 'text',
      visible: true,
      locked: false,
      transform: [1, 0, 0, 1, p.wx, p.wy],
      appearance: { fills: [], strokes: [], opacity: 1, blend: 'normal', effects: [] },
      text: 'Text',
      box: { w: 0, h: 0, maxLines: 0, minSize: 6 },
      style: {
        family: f.family,
        weight: f.weight,
        size: Math.max(12, Math.round(36 * p.px * 2) / 2 || 36),
        color: doc.swatches.some((s) => s.id === 'brand-text')
          ? { swatchId: 'brand-text', alpha: 1 }
          : { rgb: [0, 0, 0], alpha: 1 },
        tracking: 0,
        leading: 1.15,
        caps: false,
        align: 'left',
        valign: 'top',
      },
      bind: { role: 'free' },
    };
    useDesign.getState().run(addNode(n));
    useDesign.getState().endGesture();
    useDesignUi.getState().set({ selection: [n.id], tool: 'select', dock: 'ad' });
  }
  move(_p: ToolPointer, h: ToolHost) {
    h.setCursor('text');
  }
  up() {}
}
